// Ebook route
export const requestEbookApiRoute = "support/ebooks/requests";

//Business types route
export const businessTypeApiRoute = "/customer-types";

// Countries route
export const countriesRoute = "countries";
